var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ArticleWrapper = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = require("./css");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    * {\n        ", ";\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    strong,\n    b {\n        ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ArticleWrapper = _styledComponents.default.div(_templateObject(), _css.text, function (props) {
  return "font-weight: " + (props.theme && props.theme.fontFamilyBold ? 'bold' : 'normal') + ";font-family: " + (props.theme && props.theme.fontFamilyBold ? props.theme.fontFamilyBold : 'Sport1-Bold') + ";";
});

exports.ArticleWrapper = ArticleWrapper;
ArticleWrapper.defaultProps = {
  size: 'medium',
  color: 'font.main'
};
var _default = ArticleWrapper;
exports.default = _default;